export default __webpack_public_path__ + "static/media/night.e22ed01c.svg";